// extracted by mini-css-extract-plugin
module.exports = {"table":"styles__table___1n6Y9"};